const apiUrl = process.env.REACT_APP_API_URL;
export const GetBbddProblemaIdUsuariId = async (id_problema: string, id_usuari: string, uid: any, tipus: string, schema: string, accio?: string, nota?: number, id_practica?: string, feedbackJson?: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/problemes/${id_problema}/usuaris/${id_usuari}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ uid, tipus, schema, accio, nota, idPractica: id_practica, idActivitat: id_practica, feedbackJson })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
